module.exports = __webpack_public_path__ + "img/Wp_2038.6d78c68d.png";